export default __webpack_public_path__ + "static/mobile-menu-background-a5f0b9e4122ea9a7f1d28b54c015fcd7.jpg";